// extracted by mini-css-extract-plugin
export var csatScore = "_kb-5";
export var header = "_kb-1";
export var panelWrapper = "_kb-2";
export var postPreview = "_kb-3";
export var rightContent = "_kb-0";
export var wrappingText = "_kb-4";